import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Blank layout component for pages that don't need topbar/sidebar
 * Examples: Login, Error pages, Maintenance pages
 */
@Component({
  selector: 'app-blank-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './blank-layout.component.html',
  styleUrl: './blank-layout.component.css',
})
export class BlankLayoutComponent {
}

